import { render, staticRenderFns } from "./WebhooksCard.vue?vue&type=template&id=352bd408&"
import script from "./WebhooksCard.vue?vue&type=script&lang=js&"
export * from "./WebhooksCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports